import React from "react";

import "./style.less";

export default function GenericDashboardBox({ children }) {
  return <div className="dashboard-box">{children}</div>;
}
